// import React, { useEffect, useState } from "react";
// import SearchIcon from "@mui/icons-material/Search";
// import toast from "react-hot-toast";
// import { Eye } from "lucide-react";
// import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
// import InvoiceSaleModal from "../../Components/InvoiceSaleModal";
// import salesService from "../../Services/salesService";
// import moment from "moment";

// const Sales = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isOpen, setIsOpen] = useState(false);
//   const [selectedSale, setSelectedSale] = useState(null);

//   useEffect(() => {
//     const getSales = async () => {
//       try {
//         setLoading(true);
//         const response = await salesService.fetchAll();
//         console.log(response);
//         setRecords(response.sales);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching Sales");
//       }
//     };
//     getSales();
//   }, []);

//   useEffect(() => {
//     const filteredResult =
//       records?.filter((item) =>
//         item?.customer_name?.toLowerCase().includes(searchData.toLowerCase())
//       ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, records]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//   };

//   const handleViewInvoice = async (saleId) => {
//     try {
//       setLoading(true);
//       const response = await salesService.fetchSingle(saleId);
//       console.log("Selected Sale Details:", response.sale);
//       setSelectedSale(response.sale);
//       setIsOpen(true);
//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//       toast.error("Error fetching sale details");
//     }
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">Sales</h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">
//           {filteredData?.length || 0} records found
//         </h1>

//         <div className="flex mt-8 flex-row justify-between px-[3%]">
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Sales Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 border-b-2 border-gray-200 focus:border-primary focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-400 ml-2" />
//           </div>
        
//         </div>

//         <div className="mx-[3%]">
//           <table className="w-full border-collapse rounded-lg overflow-hidden shadow-xl shadow-gray-300">
//             <thead>
//               <tr className="bg-primary text-white capitalize leading-normal text-xs text-left">
//                 <th className="p-4 w-[10%]">Sale</th>
//                 <th className="p-4 w-[25%]">Customer Name</th>
//                 <th className="p-4 w-[15%]">Amount</th>
//                 <th className="p-4 w-[15%]">Sale Date</th>
//                 <th className="p-4 w-[15%] text-center">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((sale, index) => (
//                 <tr key={sale?.id} className="text-xs border-t border-gray-200">
//                   <td className="p-3 w-[10%] text-left font-bold text-primary">
//                     {index + 1}.
//                   </td>
//                   <td className="p-3 w-[25%] text-left font-bold">
//                     {sale?.customer_name}
//                   </td>
//                   <td className="p-3 w-[15%] text-left">{sale?.amount}</td>
//                   <td className="p-3 w-[15%] text-left">
//                     {moment(sale.date).format("ll")}
//                   </td>
//                   <td className="p-3 w-[15%] text-center">
//                     <button onClick={() => handleViewInvoice(sale.id)}>
//                       <Eye className="w-5 h-5 text-gray-500 hover:text-primary cursor-pointer" />
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div className="flex justify-center my-4">
//           <Stack spacing={2}>
//             <Pagination
//               count={Math.ceil(filteredData.length / itemsPerPage)}
//               page={currentPage}
//               onChange={handlePageChange}
//               variant="outlined"
//               shape="rounded"
//             />
//           </Stack>
//         </div>
//       </div>
//       <InvoiceSaleModal
//         open={isOpen}
//         onClose={() => setIsOpen(false)}
//         sale={selectedSale}
//       />
//     </div>
//   );
// };

// export default Sales;

import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import InvoiceSaleModal from "../../Components/InvoiceSaleModal";
import salesService from "../../Services/salesService";
import moment from "moment";
import { MdSearch, MdReceiptLong, MdVisibility, MdChevronLeft, MdChevronRight } from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const ITEMS_PER_PAGE = 10;

const Sales = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSale, setSelectedSale] = useState(null);

  useEffect(() => {
    const getSales = async () => {
      try {
        setLoading(true);
        const response = await salesService.fetchAll();
        setRecords(response.sales);
      } catch (error) {
        toast.error("Error fetching Sales");
      } finally {
        setLoading(false);
      }
    };
    getSales();
  }, []);

  useEffect(() => {
    const result =
      records?.filter((item) =>
        item?.customer_name?.toLowerCase().includes(searchData.toLowerCase())
      ) || [];
    setFilteredData(result);
    setCurrentPage(1);
  }, [searchData, records]);

  useEffect(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    setPaginatedData(filteredData?.slice(start, start + ITEMS_PER_PAGE) || []);
  }, [currentPage, filteredData]);

  const handleViewInvoice = async (saleId) => {
    try {
      setInvoiceLoading(saleId);
      const response = await salesService.fetchSingle(saleId);
      setSelectedSale(response.sale);
      setIsOpen(true);
    } catch (error) {
      toast.error("Error fetching sale details");
    } finally {
      setInvoiceLoading(null);
    }
  };

  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  const totalRevenue = records.reduce(
    (sum, s) => sum + parseFloat(s.amount || 0),
    0
  );

  const todaySales = records.filter(
    (s) => moment(s.date).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")
  ).length;

  const pageNumbers = () => {
    const pages = [];
    const delta = 2;
    for (
      let i = Math.max(1, currentPage - delta);
      i <= Math.min(totalPages, currentPage + delta);
      i++
    ) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .fade-up { animation: fadeUp 0.5s ease both; }
        * { font-family: 'DM Sans', sans-serif; }
        .serif { font-family: 'DM Serif Display', serif; }
      `}</style>

      <div className="min-h-screen bg-[#f4f7fb] py-5 px-3 sm:py-8 sm:px-4 fade-up">
        <div className="max-w-[1400px] mx-auto">

          {/* ── Page Header ── */}
          <div className="mb-5 sm:mb-8">
            <div className="flex items-center gap-2.5 sm:gap-3 mb-1">
              <div
                className="w-8 h-8 sm:w-9 sm:h-9 rounded-xl flex items-center justify-center shrink-0"
                style={{ background: "linear-gradient(135deg, #00A95B, #007a40)" }}
              >
                <MdReceiptLong size={17} className="text-white" />
              </div>
              <h1 className="text-[#0a2540] text-[20px] sm:text-[26px] serif leading-tight">Sales</h1>
            </div>
            <p className="text-[#8a9bb0] text-[12px] sm:text-sm ml-[42px] sm:ml-12">
              {filteredData.length} record{filteredData.length !== 1 ? "s" : ""} found
            </p>
          </div>

          {/* ── Summary Cards ── */}
          {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mb-6">
            <SummaryCard
              label="Total Sales"
              value={records.length}
              color="#0a2540"
              bg="#f4f7fb"
            />
            <SummaryCard
              label="Today's Sales"
              value={todaySales}
              color="#e96f1f"
              bg="#fff7f0"
              border="border-orange-100"
            />
            <SummaryCard
              label="Total Revenue"
              value={`Rs. ${totalRevenue.toLocaleString("en-PK", { minimumFractionDigits: 2 })}`}
              color="#00A95B"
              bg="#f0fdf7"
              border="border-emerald-100"
              highlight
            />
          </div> */}

          {/* ── Search + Table Card ── */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] overflow-hidden">

            {/* Search Bar */}
            <div className="px-4 py-3.5 sm:px-6 sm:py-4 border-b border-[#eef1f6]">
              <div className="relative w-full sm:w-[360px]">
                <MdSearch
                  size={18}
                  className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#8a9bb0] pointer-events-none"
                />
                <input
                  type="search"
                  placeholder="Search by customer name..."
                  value={searchData}
                  onChange={(e) => setSearchData(e.target.value)}
                  className="w-full pl-10 pr-4 py-[10px] bg-[#f8fafc] border-[1.5px] border-[#dde4ed] rounded-xl text-[14px] text-[#0a2540] outline-none transition-all placeholder:text-[#b0bcc9] focus:border-[#00A95B] focus:shadow-[0_0_0_4px_rgba(0,169,91,0.1)] focus:bg-white"
                />
              </div>
            </div>

            {/* ── Table view: md and up ── */}
            <div className="hidden md:block overflow-x-auto">
              <table className="w-full text-left">
                <thead>
                  <tr style={{ background: "#00A95B" }}>
                    {["Sr.no.", "Customer Name", "Amount", "Sale Date", "Action"].map((h) => (
                      <th
                        key={h}
                        className={`px-5 py-3.5 text-[11px] font-semibold uppercase tracking-[0.6px] text-white whitespace-nowrap ${h === "Action" ? "text-center" : ""}`}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center py-16">
                        <div className="flex flex-col items-center gap-3 text-[#8a9bb0]">
                          <AiOutlineLoading3Quarters
                            size={28}
                            className="animate-spin text-[#00A95B]"
                          />
                          <span className="text-sm">Loading sales…</span>
                        </div>
                      </td>
                    </tr>
                  ) : paginatedData.length > 0 ? (
                    paginatedData.map((sale, index) => (
                      <tr
                        key={sale?.id}
                        className={`text-[13px] border-b border-[#f0f4f8] transition-colors ${
                          index % 2 === 0 ? "bg-white" : "bg-[#fafbfd]"
                        } hover:bg-[#f0fdf7]`}
                      >
                        <td className="px-5 py-3.5 font-bold text-[#00A95B]">
                          {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                        </td>
                        <td className="px-5 py-3.5 font-semibold text-[#0a2540]">
                          {sale?.customer_name}
                        </td>
                        <td className="px-5 py-3.5">
                          <span className="font-semibold text-[#0a2540]">
                            Rs.{" "}
                            {parseFloat(sale?.amount).toLocaleString("en-PK", {
                              minimumFractionDigits: 2,
                            })}
                          </span>
                        </td>
                        <td className="px-5 py-3.5 text-[#4a6080]">
                          <span className="inline-flex items-center gap-1.5 text-[12px] bg-[#f4f7fb] border border-[#eef1f6] px-2.5 py-1 rounded-lg">
                            {moment(sale.date).format("ll")}
                          </span>
                        </td>
                        <td className="px-5 py-3.5 text-center">
                          <button
                            onClick={() => handleViewInvoice(sale.id)}
                            disabled={invoiceLoading === sale.id}
                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[12px] font-semibold border border-[#dde4ed] text-[#4a6080] hover:border-[#00A95B] hover:text-[#00A95B] hover:bg-[#f0fdf7] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            {invoiceLoading === sale.id ? (
                              <AiOutlineLoading3Quarters
                                size={13}
                                className="animate-spin"
                              />
                            ) : (
                              <MdVisibility size={14} />
                            )}
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center py-14">
                        <div className="flex flex-col items-center gap-2 text-[#b0bcc9]">
                          <MdReceiptLong size={32} className="text-[#dde4ed]" />
                          <span className="text-sm">
                            {searchData
                              ? "No sales match your search."
                              : "No sales records found."}
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Card view: below md ── */}
            <div className="md:hidden">
              {loading ? (
                <div className="flex flex-col items-center gap-3 text-[#8a9bb0] py-14">
                  <AiOutlineLoading3Quarters
                    size={26}
                    className="animate-spin text-[#00A95B]"
                  />
                  <span className="text-sm">Loading sales…</span>
                </div>
              ) : paginatedData.length > 0 ? (
                <ul className="divide-y divide-[#f0f4f8]">
                  {paginatedData.map((sale, index) => (
                    <li key={sale?.id} className="p-4 flex flex-col gap-3">
                      {/* Sr# + Customer Name */}
                      <div className="flex items-start justify-between gap-3">
                        <div className="min-w-0">
                          <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                            #{(currentPage - 1) * ITEMS_PER_PAGE + index + 1} · Customer Name
                          </span>
                          <span className="font-semibold text-[#0a2540] text-[14.5px] break-words leading-snug">
                            {sale?.customer_name}
                          </span>
                        </div>
                        <button
                          onClick={() => handleViewInvoice(sale.id)}
                          disabled={invoiceLoading === sale.id}
                          className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-[11.5px] font-semibold border border-[#dde4ed] text-[#4a6080] active:bg-[#f0fdf7] active:border-[#00A95B] active:text-[#00A95B] transition-all disabled:opacity-50 shrink-0"
                        >
                          {invoiceLoading === sale.id ? (
                            <AiOutlineLoading3Quarters size={12} className="animate-spin" />
                          ) : (
                            <MdVisibility size={13} />
                          )}
                          View
                        </button>
                      </div>

                      {/* Amount + Sale Date, each with its own label */}
                      <div className="flex items-end justify-between gap-3">
                        <div>
                          <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                            Amount
                          </span>
                          <span className="font-bold text-[#0a2540] text-[13.5px]">
                            Rs.{" "}
                            {parseFloat(sale?.amount).toLocaleString("en-PK", {
                              minimumFractionDigits: 2,
                            })}
                          </span>
                        </div>
                        <div className="text-right">
                          <span className="block text-[10px] font-semibold uppercase tracking-[0.5px] text-[#8a9bb0] mb-0.5">
                            Sale Date
                          </span>
                          <span className="inline-flex items-center text-[#4a6080] bg-[#f4f7fb] border border-[#eef1f6] px-2.5 py-1 rounded-lg text-[11.5px]">
                            {moment(sale.date).format("ll")}
                          </span>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="flex flex-col items-center gap-2 text-[#b0bcc9] py-12 px-4 text-center">
                  <MdReceiptLong size={28} className="text-[#dde4ed]" />
                  <span className="text-sm">
                    {searchData
                      ? "No sales match your search."
                      : "No sales records found."}
                  </span>
                </div>
              )}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="px-4 py-3.5 sm:px-6 sm:py-4 border-t border-[#eef1f6] flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="hidden sm:block text-[12px] text-[#8a9bb0]">
                  Showing{" "}
                  {(currentPage - 1) * ITEMS_PER_PAGE + 1}–
                  {Math.min(currentPage * ITEMS_PER_PAGE, filteredData.length)}{" "}
                  of {filteredData.length} results
                </p>

                {/* Compact prev/next + page label — mobile only */}
                <div className="flex sm:hidden items-center justify-between w-full gap-2">
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                    className="flex items-center gap-1 px-3 py-2 rounded-lg border border-[#dde4ed] text-[#4a6080] text-[12px] font-medium disabled:opacity-40 disabled:cursor-not-allowed active:enabled:border-[#00A95B] active:enabled:text-[#00A95B] transition-colors"
                  >
                    <MdChevronLeft size={16} />
                    Prev
                  </button>
                  <span className="text-[12px] font-semibold text-[#0a2540]">
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    onClick={() =>
                      setCurrentPage((p) => Math.min(totalPages, p + 1))
                    }
                    disabled={currentPage === totalPages}
                    className="flex items-center gap-1 px-3 py-2 rounded-lg border border-[#dde4ed] text-[#4a6080] text-[12px] font-medium disabled:opacity-40 disabled:cursor-not-allowed active:enabled:border-[#00A95B] active:enabled:text-[#00A95B] transition-colors"
                  >
                    Next
                    <MdChevronRight size={16} />
                  </button>
                </div>

                {/* Full numbered pagination — sm and up */}
                <div className="hidden sm:flex items-center gap-1.5">
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                    className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#dde4ed] text-[#4a6080] text-sm disabled:opacity-40 disabled:cursor-not-allowed hover:enabled:border-[#00A95B] hover:enabled:text-[#00A95B] transition-colors"
                  >
                    ‹
                  </button>

                  {pageNumbers()[0] > 1 && (
                    <>
                      <button
                        onClick={() => setCurrentPage(1)}
                        className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#dde4ed] text-[13px] text-[#4a6080] hover:border-[#00A95B] hover:text-[#00A95B] transition-colors"
                      >
                        1
                      </button>
                      {pageNumbers()[0] > 2 && (
                        <span className="text-[#b0bcc9] text-sm px-1">…</span>
                      )}
                    </>
                  )}

                  {pageNumbers().map((page) => (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`w-8 h-8 flex items-center justify-center rounded-lg border text-[13px] font-medium transition-colors ${
                        page === currentPage
                          ? "border-[#00A95B] bg-[#00A95B] text-white"
                          : "border-[#dde4ed] text-[#4a6080] hover:border-[#00A95B] hover:text-[#00A95B]"
                      }`}
                    >
                      {page}
                    </button>
                  ))}

                  {pageNumbers()[pageNumbers().length - 1] < totalPages && (
                    <>
                      {pageNumbers()[pageNumbers().length - 1] < totalPages - 1 && (
                        <span className="text-[#b0bcc9] text-sm px-1">…</span>
                      )}
                      <button
                        onClick={() => setCurrentPage(totalPages)}
                        className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#dde4ed] text-[13px] text-[#4a6080] hover:border-[#00A95B] hover:text-[#00A95B] transition-colors"
                      >
                        {totalPages}
                      </button>
                    </>
                  )}

                  <button
                    onClick={() =>
                      setCurrentPage((p) => Math.min(totalPages, p + 1))
                    }
                    disabled={currentPage === totalPages}
                    className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#dde4ed] text-[#4a6080] text-sm disabled:opacity-40 disabled:cursor-not-allowed hover:enabled:border-[#00A95B] hover:enabled:text-[#00A95B] transition-colors"
                  >
                    ›
                  </button>
                </div>
              </div>
            )}
          </div>

        </div>
      </div>

      <InvoiceSaleModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        sale={selectedSale}
      />
    </>
  );
};

/* ── Summary Card ── */
const SummaryCard = ({ label, value, color, bg, border = "border-[#eef1f6]", highlight }) => (
  <div
    className={`rounded-xl p-4 flex flex-col gap-1 border ${border} ${highlight ? "border-emerald-100" : ""}`}
    style={{ background: bg }}
  >
    <span className="text-[11px] font-semibold uppercase tracking-[0.7px] text-[#8a9bb0]">
      {label}
    </span>
    <span
      className="text-[20px] font-bold serif"
      style={{ color, fontFamily: "'DM Serif Display', serif" }}
    >
      {value}
    </span>
  </div>
);

export default Sales;